<div class="flex flex-wrap">
    <div
        class="w-8 h-8 cursor-pointer mr-1 mb-1 border-2"
        [style.backgroundColor]="color"
        [class.border-transparent]="color !== selected"
        [class.border-black]="color === selected"
        (click)="change.emit(color)"
        *ngFor="let color of availableColors"
    ></div>
    <div
        colorPicker
        [cpPosition]="pickerPosition"
        (colorPickerChange)="change.emit($event)"
        class="w-8 h-8 cursor-pointer bg-cover"
        style="
            background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAQAAABIkb+zAAADeklEQVR4Ae3bA8wlSRQF4LO2bbN/1blrK1rbRrC2bdu2vRtutN4d27ZtvJ44k54enO5+r2qS+k6c+m/3bf33CVEURVEURVFlVnP72fl2Pz/mH9aDIznHZtso68E/+DEf4AVuP6yGMBn5FP/gHEuXk1n2pz3JY7A6QtG8CW+ybpaKmcIvebr385Fszac5w9Ki4Uh7JNkaftgafDr/khEzjbd5uKBcq/WwtKqwnzsODbQqH7D5llYbfmyboxFsG/vT0rpkQgPOgzuSk7Ib5hy+2rwrADTvylez94WyjjU+iFVQP3aWzVvySeL2xWLcvhyZXSOt+xaroj7cdTmbW9h2KDLaDuFCZV02/AD1wEtzN/Y+cvA9cV02z6Jq7oz8o8WDkMMOlNdlcyeqxJal3Zq7b4gcu2+or8uGl6IqyfocYml+kvXz/0Jdl3t3taEa9k22ePWXUF7Ys5IRw52cKbwCTwy+r6/Lzf0oa/e1bNgyG6i5g5HhDmZNX5eb2a3boRz30AqMxHtjMbY3R5ZZl8mHZW/f6fmF6zNK5GZvFMe7LfUdvoKikjVtvKXeM3X3tVAML7A0iFyCYvhbGA3wOxThtmVNuAnlCHVnYjXoeJM2z+sR6h4NHX/R5nk9Qt0bIFuFM6R5Xo9Ql29D5fYThzE9Ql3+DZW7XJzn9Qh12R8qPi3O83qEuhwHFX8O6hJaCJV1U+d5PULdeVBxiDjP6xHqchJUNlGd5/UIdbtBlT0GXkeJlN9CZfMsDSh3QsVJITXQdghUNiygBkZhVaisRzgNuMdLzKL+w7m2OXT2bDANvIYieFUgDUxr3gQZwjjtP+4KFLQqpwfQwOcozn71fvX/Y2ugOHez591vn2yKMlq2Z83j7n+889rQBfLG1jA7AVVwF3k48nPskcyxLy5Zk2Mbuvt97SW3E6pkdzbmkuHH7oqW7VG9vTawaZXt5ix7rvxOyvhgRbs/qHlX+JD/IZ8+UbY0wRd3cgUNPA+f7OvSLewNn/bagIPLvfeDVeCXa7V5Ze4A+McTy3yY4XaCf7y0RAN3IAR2feEWxjfyX5jwpT8h3VvWgzeZr116uYz8f/GVXaAL6avHnIuQuFbrIzYwA2FJ1hS/fv8/wqP8AMJdgTAlm/Im9lzuBfQvVkXI3H7L+hEQe7Zut7L+DCu1gbxm97VQuSiKoiiKomgRajYh74++j1MAAAAASUVORK5CYII=);
        "
    ></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/shared/components/color-selector/color-selector.component.html